import { render, staticRenderFns } from "./disclosure.vue?vue&type=template&id=32309b45&scoped=true&"
import script from "./disclosure.vue?vue&type=script&lang=js&"
export * from "./disclosure.vue?vue&type=script&lang=js&"
import style0 from "./disclosure.vue?vue&type=style&index=0&id=32309b45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32309b45",
  null
  
)

export default component.exports